import { createFileRoute, Link } from '@tanstack/react-router';

import { useAuth } from '@/lib/auth/hooks/useAuth';
import LoadingCard from '@/lib/loading/components/LoadingCard';
import { Button } from '@heroui/react';
import { ReactNode, useState } from 'react';
import EditPersonalInformationForm from '@/components/account/settings/EditPersonalInformationForm';

export const Route = createFileRoute('/account/settings')({
    component: RouteComponent,
});

function Section({ children }: { children: ReactNode }) {
    return <div className='border-b border-gray-300 last:border-b-0  '>{children}</div>;
}

function RouteComponent() {
    const { user } = useAuth();
    const [editPersonalInfo, setEditPersonalInfo] = useState(false);

    if (!user) {
        return (
            <div className='m-5 mx-auto max-w-2xl'>
                <LoadingCard />
            </div>
        );
    }
    return (
        <div className=' mx-2 max-w-2xl md:mx-auto '>
            <div className=' py-2 text-lg font-semibold'>Account settings</div>
            <div className='simple-card  grid gap-y-3 p-3'>
                <Section>
                    <div className='flex flex-row items-center justify-between'>
                        <div className='font-semibold'>Personal Information</div>
                        <Button
                            color='primary'
                            onPress={
                                editPersonalInfo
                                    ? () => setEditPersonalInfo(false)
                                    : () => setEditPersonalInfo(true)
                            }>
                            {editPersonalInfo ? 'Cancel' : 'Edit'}
                        </Button>
                    </div>
                    {editPersonalInfo ? (
                        <EditPersonalInformationForm user={user} onSave={() => setEditPersonalInfo(false)} />
                    ) : (
                        <div className='grid grid-cols-3 gap-x-4 justify-self-start'>
                            <div className='col-span-1   font-semibold'>Email:</div>
                            <div className='col-span-2'>{user?.email}</div>
                            <div className='col-span-1   font-semibold'>First Name:</div>
                            <div className='col-span-2'>{user?.first_name}</div>
                            <div className='col-span-1   font-semibold'>Last Name:</div>
                            <div className='col-span-2'>{user?.last_name}</div>
                        </div>
                    )}
                </Section>

                <Section>
                    <div className='flex flex-row items-center justify-between'>
                        <div>Reset password</div>
                        <Link to='/auth/reset-password'>
                            <Button color='primary'>Reset</Button>
                        </Link>
                    </div>
                </Section>
            </div>
        </div>
    );
}
